import { Container } from 'metrix-common3';
import { useEffect } from 'react';
import TriageFooter from './Footer';
import TriageHeader from './Header';
import TriageResults from './Results';

const Triage = (props) => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: only re-run on listed deps
    useEffect(() => {
        props.doReduceView('triage');

        if (props.query.triage.search) {
            props.doQueryTriagePolicies();
        } else {
            props.doGetTriagePolicies();
        }
    }, [props.query.triage.search]);

    return (
        <Container>
            <TriageHeader {...props} />
            <TriageFooter {...props} />
            <TriageResults {...props} />
            <TriageFooter {...props} />
        </Container>
    );
};

export default Triage;
